class FostrCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('fostr-slider-component');
    this.controls = this.querySelector('fostr-carousel-controls-component');
  }

  currentSlideUpdated(index) {
    if (this.controls) {
      this.controls.currentSlideUpdated(index);
    }
  }
}

class FostrCarouselControlsComponent extends HTMLElement {
  constructor() {
    super();
    // this.initialiseSlideIndicators();
    this.currentSlideIndex = 0;
  }

  initialiseButtons() {
    let nextButton = document.createElement('slide-button');
    nextButton.setAttribute("data-next", true);
    nextButton.onclick = () => {
      let numberOfSlides = this.parentElement.slider.slides.length;
      let slide = this.currentSlideIndex + 1;
      let next = this.currentSlideIndex + 1;
      if (previousButton.style.display == 'none') {
        previousButton.style.display = 'block';
      }
      console.log(next);
      if (slide == numberOfSlides - 2) {
        // next = 0;
        nextButton.style.display = 'none';
        return;
      }
      this.goToSlide(next);
    }

    let previousButton = document.createElement('slide-button');
    previousButton.setAttribute("data-next", false);
    previousButton.onclick = () => {
      let numberOfSlides = this.parentElement.slider.slides.length;
      let slide = this.currentSlideIndex + 1;
      let previous = this.currentSlideIndex - 1;
      if (nextButton.style.display == 'none') {
        nextButton.style.display = 'block';
      }
      if (slide <= 1) {
        previous = numberOfSlides - 1;
        previousButton.style.display = 'none';
        return;
      }
      this.goToSlide(previous);
    }
          
    this.appendChild(previousButton);
    this.appendChild(nextButton);
  }

  initialiseSlideIndicators() {
    this.parentElement.slider.slides.forEach((slide, index) => {
      this.addSlideIndicator(index);
    });
  }

  addSlideIndicator(index) {
    let indicator = document.createElement('slide-indicator');
    indicator.setAttribute("data-index", index);
    if (index == 0) {
      indicator.setAttribute("data-current", '');
    }
    indicator.onclick = () => this.goToSlide(index);
    this.appendChild(indicator);
  }

  currentSlideUpdated(slideIndex) {
    this.currentSlideIndex = parseInt(slideIndex);
    let indicators = this.querySelectorAll('slide-indicator');
    indicators.forEach((indicator, index) => {
      if (slideIndex == index) {
        indicator.setAttribute("data-current", '');
      } else {
        indicator.removeAttribute("data-current");
      }
    })
  }

  goToSlide(index) {
    this.parentElement.slider.scrollToSlideByIndex(index);
  }
}

class FostrSliderComponent extends HTMLElement {
  beingClicked = false;
  last_changed_frame = 0;
  scrollingLeft = false;
  hasScrolled = false;
  controller = new AbortController();
  bounced = 0;
  interval;
  lastXCoordinate;
  currentSlide;

  constructor() {
    super();
    this.slides = this.querySelectorAll('fostr-slide-component');
    this.currentSlide = this.slides.item(0);
    this.currentSlide.current = true;
    // if (this.supportsSmoothScrolling()) {
    //   this.setupEventListeners();
    //   this.interval = setInterval(() => this.bounceOnLoad(), 1000);
    // } else {
      this.setupNoSmoothScroll();
    // }
  }

  bounceOnLoad() {
    // if (this.bounced < 2) { window.requestAnimationFrame(()=> this.scroll({
    //     top: 0,
    //     left: 100,
    //     behavior: 'smooth'
    //   }));
    //   this.bounced++;
    // } else {
      window.clearInterval(this.interval);
    // }
  }

  setupNoSmoothScroll() {
    this.style.scrollSnapType = 'x mandatory';
    this.style.webkitOverflowScrolling = 'touch';
    this.style.webkitScrollSnapType = 'x mandatory';

    this.slides.forEach(slide => {
      slide.style.scrollSnapAlign = 'center';
    });

    this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
    this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
    this.addEventListener('mousemove', event => this.mouseMoveEvent(event), true);
    this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
  }

  setupEventListeners() {
    this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
    this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
    this.addEventListener('mousemove', event => this.mouseMoveEvent(event), true);
    this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
    this.addEventListener("scroll", event => this.scrollEvent(event), { signal: this.controller.signal });
  }

  scrollEvent(event) {
    this.controller.abort();
    this.controller = new AbortController();
    this.hasScrolled = false;
    this.waitForScrollEnd().then(() => this.scrollToCurrentSlide());
  }

  supportsSmoothScrolling() {
    const body = document.body;
    const scrollSave = body.style.scrollBehavior;
    body.style.scrollBehavior = 'smooth';
    const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
    body.style.scrollBehavior = scrollSave;
    return hasSmooth;
  }

  waitForScrollEnd() {
    return new Promise( (resolve) => {
      this.tick(0, this, resolve);
    });
  }

  tick(frames, component, resolve) {
    if (frames - component.last_changed_frame >= 10) {
      resolve();
    } else {
      if (component.scrollLeft != component.lastXCoordinate) {
        component.hasScrolled = true;
        if (component.scrollLeft < component.lastXCoordinate) { 
          component.scrollingLeft=true;
        } else {
          component.scrollingLeft=false;
        }
        component.last_changed_frame=frames;
        component.lastXCoordinate=component.scrollLeft;
      } 
      requestAnimationFrame(component.tick.bind(null, frames + 1,component, resolve));
    } 
  }
  
  mouseDownEvent(event) {
    this.beingClicked=true;
    this.style.cursor="grab";
    if (!this.supportsSmoothScrolling()) {
      this.style.scrollSnapType='none';
      this.style.webkitOverflowScrolling='none';
      this.style.webkitScrollSnapType='none';
    } 
    event.preventDefault();
  }
  
  mouseUpEvent(event) {
    this.beingClicked=false;
    this.style.cursor=""; 
    if (!this.supportsSmoothScrolling()) {
      this.style.scrollSnapType='x mandatory';
      this.style.webkitOverflowScrolling='touch';
      this.style.webkitScrollSnapType='x mandatory';
    }
  }
  
  mouseMoveEvent(event) {
    if (this.beingClicked) {
      this.scrollLeft -=event.movementX;
    } 
  }
  
  mouseLeaveEvent(event) {
    if (!this.supportsSmoothScrolling()) {
      this.style.scrollSnapType='x mandatory';
      this.style.webkitOverflowScrolling='touch';
      this.style.webkitScrollSnapType='x mandatory'; 
    }
    this.beingClicked=false;
  }
  
  scrollToCurrentSlide() {
    if (this.hasScrolled) {
      this.getSlideToScrollTo();
      let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue('padding-left'));
      this.scroll({ top: 0, left: this.currentSlide.offsetLeft - computedPadding, behavior: 'smooth' });
      this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
      this.addEventListener("scroll", event=> this.scrollEvent(event), { signal: this.controller.signal });
    }
  }

  scrollToSlideByIndex(index) {
    let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue('padding-left'));
    this.scroll({
      top: 0,
      left: this.slides[index].offsetLeft - computedPadding,
      behavior: 'smooth'
    });
    this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
  }

  getSlideToScrollTo() {
    let slideFound = false;
    let indexFound;
    this.slides.forEach((slide, index) => {
      slide.current = false;
      if (this.scrollingLeft) {
        if ((slide.offsetLeft + (slide.clientWidth * .75)) >= this.scrollLeft && !slideFound) {
          this.currentSlide = slide;
          slideFound = true;
          slide.current = true;
          indexFound = index;
        }
      } else {
        if ((slide.offsetLeft + (slide.clientWidth / 4)) > this.scrollLeft && !slideFound) {
          this.currentSlide = this.slides[index];
          slideFound = true;
          slide.current = true;
          indexFound = index;
        }
      }
    });
  }
}

class FostrSlideComponent extends HTMLElement {
  current = false;
  index;
  constructor() {
    super();
  }
}

customElements.define('fostr-carousel-component', FostrCarouselComponent);
customElements.define('fostr-slider-component', FostrSliderComponent);
customElements.define('fostr-slide-component', FostrSlideComponent);
customElements.define('fostr-carousel-controls-component', FostrCarouselControlsComponent);





class FostrNestedCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('fostr-nested-slider-component');
    this.controls = this.querySelector('fostr-nested-carousel-controls-component');
  }

  currentSlideUpdated(index) {
    if (this.controls) {
      this.controls.currentSlideUpdated(index);
      
    }
  }
}

class FostrNestedCarouselControlsComponent extends HTMLElement {
  currentSlideIndex = 0;
  constructor() {
    super();
    // this.initialiseSlideIndicators();
    this.initialiseButtons();
  }

  initialiseButtons() {
    let nextButton = document.createElement('slide-button');
    nextButton.setAttribute("data-next", true);
    nextButton.onclick = () => {
      let numberOfSlides = this.parentElement.slider.slides.length;
      let slide = this.currentSlideIndex + 1;
      let next = this.currentSlideIndex + 1;
      if (previousButton.style.display == 'none') {
        previousButton.style.display = 'block';
      }
      if (slide == numberOfSlides - 4) {
        // next = 0;
        nextButton.style.display = 'none';
        return;
      }
      this.goToSlide(next);
    }
    // nextButton.innerHTML = ">";

    let previousButton = document.createElement('slide-button');
    previousButton.setAttribute("data-next", false);
    previousButton.onclick = () => {
      let numberOfSlides = this.parentElement.slider.slides.length;
      let slide = this.currentSlideIndex + 1;
      let previous = this.currentSlideIndex - 1;
      if (nextButton.style.display == 'none') {
        nextButton.style.display = 'block';
      }
      if (slide <= 1) {
        // previous = numberOfSlides - 1;
        previousButton.style.display = 'none';
        return;
      }
      this.goToSlide(previous);
    }
    // previousButton.innerHTML = "<";
          
    this.appendChild(previousButton);
    this.appendChild(nextButton);
  }

  initialiseSlideIndicators() {
    this.parentElement.slider.slides.forEach((slide, index) => {
      this.addSlideIndicator(index);
    });
  }

  addSlideIndicator(index) {
    let indicator = document.createElement('slide-indicator');
    indicator.setAttribute("data-index", index);
    if (index == 0) {
      indicator.setAttribute("data-current", '');
    }
    indicator.onclick = () => this.goToSlide(index);
    this.appendChild(indicator);
  }

  currentSlideUpdated(slideIndex) {
    this.currentSlideIndex = parseInt(slideIndex);
    let indicators = this.querySelectorAll('slide-indicator');
    indicators.forEach((indicator, index) => {
      if (slideIndex == index) {
        indicator.setAttribute("data-current", '');
      } else {
        indicator.removeAttribute("data-current");
      }
    })
  }

  goToSlide(index) {
    this.parentElement.slider.scrollToSlideByIndex(index);
  }
}

class FostrNestedSliderComponent extends HTMLElement {
  beingClicked = false;
  last_changed_frame = 0;
  scrollingLeft = false;
  hasScrolled = false;
  controller = new AbortController();
  bounced = 0;
  interval;
  lastXCoordinate;
  currentSlide;

  constructor() {
    super();
    this.slides = this.querySelectorAll('fostr-nested-slide-component');
    this.currentSlide = this.slides.item(0);
    this.currentSlide.current = true;
    if (this.supportsSmoothScrolling()) {
      this.setupEventListeners();
      this.interval = setInterval(() => this.bounceOnLoad(), 1000);
    } else {
      this.setupNoSmoothScroll();
    }    
  }

  bounceOnLoad() {
    // if (this.bounced < 2) { window.requestAnimationFrame(()=> this.scroll({
    //     top: 0,
    //     left: 100,
    //     behavior: 'smooth'
    //   }));
    //   this.bounced++;
    // } else {
      window.clearInterval(this.interval);
    // }
  }

  setupNoSmoothScroll() {
    this.style.scrollSnapType = 'x mandatory';
    this.style.webkitOverflowScrolling = 'touch';
    this.style.webkitScrollSnapType = 'x mandatory';

    this.slides.forEach(slide => {
      slide.style.scrollSnapAlign = 'center';
    });

    this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
    this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
    this.addEventListener('mousemove', event => this.mouseMoveEvent(event), true);
    this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
  }

  setupEventListeners() {
    this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
    this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
    this.addEventListener('mousemove', event => this.mouseMoveEvent(event), true);
    this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
    this.addEventListener("scroll", event => this.scrollEvent(event), { signal: this.controller.signal });
  }

  scrollEvent(event) {
    this.controller.abort();
    this.controller = new AbortController();
    this.hasScrolled = false;
    this.waitForScrollEnd().then(() => this.scrollToCurrentSlide());
  }

  supportsSmoothScrolling() {
    const body = document.body;
    const scrollSave = body.style.scrollBehavior;
    body.style.scrollBehavior = 'smooth';
    const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
    body.style.scrollBehavior = scrollSave;
    return hasSmooth;
  }

  waitForScrollEnd() {
    return new Promise( (resolve) => {
      this.tick(0, this, resolve);
    });
  }

  tick(frames, component, resolve) {
    if (frames - component.last_changed_frame >= 10) {
      resolve();
    } else {
      if (component.scrollLeft != component.lastXCoordinate) {
        component.hasScrolled = true;
        if (component.scrollLeft < component.lastXCoordinate) { 
          component.scrollingLeft=true;
        } else {
          component.scrollingLeft=false;
        }
        component.last_changed_frame=frames;
        component.lastXCoordinate=component.scrollLeft;
      } 
      requestAnimationFrame(component.tick.bind(null, frames + 1,component, resolve));
    } 
  }
  
  mouseDownEvent(event) {
    this.beingClicked=true;
    this.style.cursor="grab";
    if (!this.supportsSmoothScrolling()) {
      this.style.scrollSnapType='none';
      this.style.webkitOverflowScrolling='none';
      this.style.webkitScrollSnapType='none';
    } 
    event.preventDefault();
  }
  
  mouseUpEvent(event) {
    this.beingClicked=false;
    this.style.cursor=""; 
    if (!this.supportsSmoothScrolling()) {
      this.style.scrollSnapType='x mandatory';
      this.style.webkitOverflowScrolling='touch';
      this.style.webkitScrollSnapType='x mandatory';
    }
  }
  
  mouseMoveEvent(event) {
    if (this.beingClicked) {
      this.scrollLeft -=event.movementX;
    } 
  }
  
  mouseLeaveEvent(event) {
    if (!this.supportsSmoothScrolling()) {
      this.style.scrollSnapType='x mandatory';
      this.style.webkitOverflowScrolling='touch';
      this.style.webkitScrollSnapType='x mandatory'; 
    }
    this.beingClicked=false;
  }
  
  scrollToCurrentSlide() {
    if (this.hasScrolled) {
      this.getSlideToScrollTo();
      let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue('padding-left'));
      this.scroll({ top: 0, left: this.currentSlide.offsetLeft - computedPadding, behavior: 'smooth' });
      this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
      this.addEventListener("scroll", event=> this.scrollEvent(event), { signal: this.controller.signal });
    }
  }

  scrollToSlideByIndex(index) {
    let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue('padding-left'));
    this.scroll({
      top: 0,
      left: this.slides[index].offsetLeft - computedPadding,
      behavior: 'smooth'
    });
    this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
  }

  getSlideToScrollTo() {
    let slideFound = false;
    let indexFound;
    this.slides.forEach((slide, index) => {
      slide.current = false;
      if (this.scrollingLeft) {
        if ((slide.offsetLeft + (slide.clientWidth * .75)) >= this.scrollLeft && !slideFound) {
          this.currentSlide = slide;
          slideFound = true;
          slide.current = true;
          indexFound = index;
        }
      } else {
        if ((slide.offsetLeft + (slide.clientWidth / 4)) > this.scrollLeft && !slideFound) {
          this.currentSlide = this.slides[index];
          slideFound = true;
          slide.current = true;
          indexFound = index;
        }
      }
    });
  }
}

class FostrNestedSlideComponent extends HTMLElement {
  current = false;
  index;
  constructor() {
    super();
    
    setTimeout(() => {
      this.sliderRequired(this);
    },100);
  }

  sliderRequired(elem) {
    if (elem.parentElement.scrollWidth <= elem.parentElement.parentElement.offsetWidth) {
      elem.parentElement.parentElement.classList.add('no-slider');
    } else {
      elem.parentElement.parentElement.classList.remove('no-slider');
    }
  }
}

customElements.define('fostr-nested-carousel-component', FostrNestedCarouselComponent);
customElements.define('fostr-nested-slider-component', FostrNestedSliderComponent);
customElements.define('fostr-nested-slide-component', FostrNestedSlideComponent);
customElements.define('fostr-nested-carousel-controls-component', FostrNestedCarouselControlsComponent);
